import React, { useState } from "react";
import "../styles/components/Header.scss";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";

const Header = () => {
  const { i18n } = useTranslation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="header-class">
      <nav className="gnb__nav" role="navigation">
        <div className="gnb__bar">
          <div className="gnb__bar-inner">
            <div>
              {i18n.language === "hk" ? (
                <a className="gnb__logo" href="https://www.samsung.com/hk/">
                  <span className="hidden">Samsung</span>
                </a>
              ) : (
                <a className="gnb__logo" href="https://www.samsung.com/hk_en/">
                  <span className="hidden">Samsung</span>
                </a>
              )}
            </div>
            <div className="gnb__mobile-menu">
              <div
                className="gnb__menu-btn"
                onClick={() => setIsMenuOpen(true)}
              >
                <span className="hidden">Open the Menu</span>
                <svg className="icon" id="menu-bold" viewBox="0 0 96 96">
                  <path d="M83 70v8H13v-8h70zm0-26v8H13v-8h70zm0-26v8H13v-8h70z"></path>
                </svg>
              </div>
            </div>
            <div
              className={isMenuOpen ? "gnb__menu-wrap open" : "gnb__menu-wrap"}
            >
              <div className="gnb__depth1-container">
                <div className="gnb__main">
                  <ul
                    className={isMenuOpen ? "gnb__depth1 open" : "gnb__depth1"}
                  >
                    <li className="gnb__depth1-menu">
                      {i18n.language === "hk" ? (
                        <a
                          className="gnb__depth1-link"
                          href="https://www.samsung.com/hk/offer/online-shop/"
                        >
                          <span className="gnb__depth1-link-text">
                            <Trans i18nKey="header:shop" />
                          </span>
                        </a>
                      ) : (
                        <a
                          className="gnb__depth1-link"
                          href="https://www.samsung.com/hk_en/offer/online-shop/"
                        >
                          <span className="gnb__depth1-link-text">
                            <Trans i18nKey="header:shop" />
                          </span>
                        </a>
                      )}
                    </li>
                    <li className="gnb__depth1-menu">
                      {i18n.language === "hk" ? (
                        <a
                          className="gnb__depth1-link"
                          href="https://www.samsung.com/hk/mobile/"
                        >
                          <span className="gnb__depth1-link-text">
                            <Trans i18nKey="header:mobile" />
                          </span>
                        </a>
                      ) : (
                        <a
                          className="gnb__depth1-link"
                          href="https://www.samsung.com/hk_en/mobile/"
                        >
                          <span className="gnb__depth1-link-text">
                            <Trans i18nKey="header:mobile" />
                          </span>
                        </a>
                      )}
                    </li>
                    <li className="gnb__depth1-menu">
                      <a
                        className="gnb__depth1-link"
                        href="https://www.samsung.com/hk/tvs/"
                      >
                        <span className="gnb__depth1-link-text">
                          <Trans i18nKey="header:tv" />
                        </span>
                      </a>
                    </li>
                    <li className="gnb__depth1-menu">
                      <a
                        className="gnb__depth1-link"
                        href="https://www.samsung.com/hk/home-appliances/"
                      >
                        <span className="gnb__depth1-link-text">
                          <Trans i18nKey="header:home" />
                        </span>
                      </a>
                    </li>
                    <li className="gnb__depth1-menu">
                      <a
                        className="gnb__depth1-link"
                        href="https://www.samsung.com/hk/computers/all-computers/"
                      >
                        <span className="gnb__depth1-link-text">
                          <Trans i18nKey="header:computing" />
                        </span>
                      </a>
                    </li>
                    <li className="gnb__depth1-menu">
                      <a
                        className="gnb__depth1-link"
                        href="https://www.samsung.com/hk/monitors/"
                      >
                        <span className="gnb__depth1-link-text">
                          <Trans i18nKey="header:displays" />
                        </span>
                      </a>
                    </li>
                    <li className="gnb__depth1-menu">
                      <a
                        className="gnb__depth1-link"
                        href="https://www.samsung.com/hk/mobile-accessories/"
                      >
                        <span className="gnb__depth1-link-text">
                          <Trans i18nKey="header:accessories" />
                        </span>
                      </a>
                    </li>
                    <li className="gnb__depth1-menu">
                      <a
                        className="gnb__depth1-link"
                        href="https://www.samsung.com/hk/smartthings/do-the-smartthings/"
                      >
                        <span className="gnb__depth1-link-text">
                          {" "}
                          <Trans i18nKey="header:smart_things" />
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="gnb__sub">
                  <ul
                    className={isMenuOpen ? "gnb__depth1 open" : "gnb__depth1"}
                    role="menubar"
                  >
                    <li className="gnb__depth1-menu" role="presentation">
                      {i18n.language === "hk" ? (
                        <a
                          className="gnb__depth1-link"
                          href=" https://www.samsung.com/hk/offer/"
                        >
                          <span className="gnb__depth1-link-text">
                            <Trans i18nKey="header:offers" />
                          </span>
                        </a>
                      ) : (
                        <a
                          className="gnb__depth1-link"
                          href=" https://www.samsung.com/hk_en/offer/"
                        >
                          <span className="gnb__depth1-link-text">
                            <Trans i18nKey="header:offers" />
                          </span>
                        </a>
                      )}
                    </li>
                    <li className="gnb__depth1-menu" role="presentation">
                      {i18n.language === "hk" ? (
                        <a
                          className="gnb__depth1-link"
                          href="https://www.samsung.com/hk/support/"
                        >
                          <span className="gnb__depth1-link-text">
                            <Trans i18nKey="header:support" />
                          </span>
                        </a>
                      ) : (
                        <a
                          className="gnb__depth1-link"
                          href="https://www.samsung.com/hk_en/support/"
                        >
                          <span className="gnb__depth1-link-text">
                            <Trans i18nKey="header:support" />
                          </span>
                        </a>
                      )}
                    </li>
                    <li className="gnb__depth1-menu">
                      {i18n.language === "hk" ? (
                        <a
                          className="gnb__depth1-link"
                          href="https://www.samsung.com/hk/business/"
                        >
                          <span className="gnb__depth1-link-text">
                            <Trans i18nKey="header:business" />
                          </span>
                        </a>
                      ) : (
                        <a
                          className="gnb__depth1-link"
                          href="https://www.samsung.com/hk_en/business/"
                        >
                          <span className="gnb__depth1-link-text">
                            {" "}
                            <Trans i18nKey="header:business" />
                          </span>
                        </a>
                      )}
                    </li>
                  </ul>
                </div>
              </div>

              <div
                className="gnb__menu-close"
                onClick={() => setIsMenuOpen(false)}
              >
                <span className="hidden">Close Menu</span>
                <svg
                  className="icon"
                  id="delete-bold"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 96 96"
                >
                  <path d="M79.17 11.17L48 42.34 16.83 11.17l-5.66 5.66L42.34 48 11.17 79.17l5.66 5.66L48 53.66l31.17 31.17 5.66-5.66L53.66 48l31.17-31.17z"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
